// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2B4-P","col":"styles_col__3KaA7","fulfillmentStatus":"styles_fulfillmentStatus__2IYoh","emailCol":"styles_emailCol__UofT8"};